"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M11.87 9.17s.01 0 0 0l-3.5-4C8.28 5.07 8.15 5 8 5s-.28.07-.37.17l-3.5 4a.495.495 0 00.37.83h7a.495.495 0 00.37-.83z"];
//# sourceMappingURL=caret-up.js.map